import { render, staticRenderFns } from "./PaymentGroups.vue?vue&type=template&id=0f05c7ee&"
import script from "./PaymentGroups.vue?vue&type=script&lang=js&"
export * from "./PaymentGroups.vue?vue&type=script&lang=js&"
import style0 from "./PaymentGroups.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports